// Sooquna support sessions, announcements and maintenance (specs 31).
const platformEn = {
  "support.title": "Sooquna support access",
  "support.description": "Let Sooquna's support team look at your store when you ask for help. Each visit needs a support ticket, lasts at most 30 minutes, is view-only unless you agree to changes, and shows in your activity log.",
  "support.allowed_now": "Allowed",
  "support.denied_now": "Not allowed",
  "support.setting.default": "Automatic",
  "support.setting.default_hint": "Allowed while you're on the free trial, then off.",
  "support.setting.allowed": "Always allow",
  "support.setting.allowed_hint": "Support can open a session whenever you have a ticket with us.",
  "support.setting.denied": "Don't allow",
  "support.setting.denied_hint": "Support can't open your store, even with a ticket. Turning this off ends any session in progress.",
  "support.owner_only": "Only the store owner can change this.",
  "support.banner": "Sooquna support ({operator}) is viewing this store",
  "support.mode_read": "View only",
  "support.mode_write": "Changes allowed",
  "support.ends_in": "{minutes, plural, =0 {Ending now} one {Ends in # minute} other {Ends in # minutes}}",
  "platform.maintenance": "Sooquna is under maintenance. Changes are paused for a few minutes; you can keep browsing.",
  "platform.learn_more": "Learn more",
  "platform.dismiss": "Dismiss",
  "platform.news": "News from Sooquna",
};

export default platformEn;
